// Errors in the app are kept for "Report a problem" and logged to the server (REQ-OPS-03, REQ-OPS-08).
type ClientError = { at: string; message: string; context?: unknown };
const recent: ClientError[] = [];

let sentThisMinute = 0;
setInterval(() => { sentThisMinute = 0; }, 60_000);

export function recordClientError(message: string, context?: unknown) {
  recent.unshift({ at: new Date().toISOString(), message, context });
  recent.splice(20);
  window.dispatchEvent(new CustomEvent("rk:client-error", { detail: { message, context } }));
  // Also to the server's error log, at most a few a minute, never blocking the screen.
  if (sentThisMinute++ < 5 && navigator.onLine) {
    void import("./api").then(({ performOnline }) => performOnline("error.log" as never, { message, context: { ...(context as object), page: location.pathname } })).catch(() => undefined);
  }
}

export function recentErrors(): ClientError[] {
  return [...recent];
}

export function installGlobalErrorHandlers() {
  window.addEventListener("error", (e) => recordClientError(e.message, { source: e.filename, line: e.lineno }));
  window.addEventListener("unhandledrejection", (e) => recordClientError(String((e.reason as Error)?.message ?? e.reason)));
}
